import {FaCheck} from "react-icons/fa";
import {IoClose, IoCloseSharp} from "react-icons/io5";
import {useEffect, useState} from "react";
import {IoMdClose} from "react-icons/io";

const QuizResultCard = ({question, options}: any) => {

    return (<>
        <div className="bg-white p-6 mb-2 rounded-xl shadow-sm max-w-md mx-auto">
            <h2 className="font-semibold text-gray-800 mb-4">{question}</h2>
            <ul className="space-y-2">
                {options?.length > 0 && options.map((opt: any, index: any) => (
                    <li key={'option' + index} className="flex items-center">
            <span
                className={`mr-2 ${
                    opt?.is_correct
                        ? "text-green-600 font-semibold"
                        : opt?.user_option_text?.includes(opt.option_text)
                            ? "text-red-500 font-semibold"
                            : "text-gray-800"
                }`}
            >
              {opt.option_text}
            </span>
                        {opt?.is_correct && <FaCheck className="text-green-600 ml-2"/>}
                        {opt?.user_option_text?.includes(opt.option_text) && opt.is_correct === false && (
                            <IoCloseSharp className="text-red-600 ml-2" style={{ fontSize: "1.4rem" }}/>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    </>);
};

export default QuizResultCard;